<template>
  <div>
    <div style="background-color: lightgray; padding: 10px; width: 200px; position: fixed; height: 100vh;">
      <div v-for="(component, index) in components">
        <button @click="select(index)">{{ component.name }}</button>
      </div>
      <br/>
      <span class="descripton">{{ currentComponent.description }}</span>
    </div>
    <div class="component_container">
      <component v-bind:is="currentComponent"></component>
    </div>
  </div>
</template>

<script>
  import AulaSetup from './components/Aula/Setup'
  import DirectDaySelector from './components/VacationDaysSelector/DirectDaySelector'
  import Hello from './components/Hello'
  import VacationDaysSelector from './components/VacationDaysSelector/VacationDaysSelector'

  export default {
    components: {AulaSetup, DirectDaySelector, Hello, VacationDaysSelector},
    data () {
      return {
        selected: 0,
        components: [AulaSetup, DirectDaySelector, Hello, VacationDaysSelector],
        currentComponent: AulaSetup
      }
    },
    created () {
      this.select(this.selected)
    },
    methods: {
      select (index) {
        this.currentComponent = this.components[index]
      }
    }
  }
</script>

<style scoped>
  .component_container {
    border: 2px solid palevioletred;
    position: absolute;
    left: 200px;
  }
</style>



// WEBPACK FOOTER //
// ComponentViewer.vue?3e9d839f